import { render, staticRenderFns } from "./QQuilityRxLeaderboards.vue?vue&type=template&id=2c1aad68&"
import script from "./QQuilityRxLeaderboards.vue?vue&type=script&lang=js&"
export * from "./QQuilityRxLeaderboards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports